"use strict";

var Highlight = function () {

  var handleHighlight = function () {
    if (matchmaking) {
      $('.m-badge-highlight').highlight(matchmaking);
    }
  };

  return {
    //main function to initiate the function
    init: function() {
      handleHighlight();
    }
  };

}();

// webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Highlight;
}

jQuery(document).ready(function() {
  Highlight.init();
});